module.exports = __webpack_public_path__ + "img/红色.f397221a.jpg";